import React from 'react'

const PopArtContext = React.createContext({

})

export default PopArtContext;